import axios from 'axios';
import { polusBaseUrl, GET, POST } from '../../utils/axios-interceptor';
import { TRIGGER_SOURCE } from './constants';

const API_ENDPOINTS = {
    BANKING_PENDING_STATUS: '/unifier/getBankingPendingStatus',
    EXTRACT_BANK_PENDING: '/unifier/extractBankPending',
};

export function getBankingPendingStatus(orgId: string) {
    return axios({
        baseURL: polusBaseUrl,
        url: API_ENDPOINTS.BANKING_PENDING_STATUS,
        method: GET,
        params: { orgId },
    });
}

export function triggerExtractPendingService(orgId: string, pnoId: string) {
    return axios({
        baseURL: polusBaseUrl,
        url: API_ENDPOINTS.EXTRACT_BANK_PENDING,
        method: POST,
        data: { requestPayload: { orgId, pnoId, triggerSource: TRIGGER_SOURCE.EXTRACT_NOW } },
    });
}
